import { helper } from '@ember/component/helper';

const matchEndSuffix = /-end$/;

export default helper(function hasEndSuffixHelper([ text ]) {
  return matchEndSuffix.test(text);
});
